/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocXIcon24Solid = forwardRef('DocXIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2h4.05v5.3a2.75 2.75 0 0 0 2.75 2.75H20V18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm6.74 11.497a.875.875 0 1 0-1.237-1.237L12 13.763l-1.503-1.503a.875.875 0 0 0-1.237 1.237L10.763 15 9.26 16.503a.875.875 0 1 0 1.237 1.237L12 16.237l1.503 1.503a.875.875 0 1 0 1.237-1.237L13.237 15l1.503-1.503Z" }),
        React.createElement("path", { d: "M20 8.51v.04h-5.2c-.69 0-1.25-.56-1.25-1.25V2.06L20 8.51Z" })));
});
